import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const ProceedSection = ({ isAuthenticated }) => {
  // Determine the link target based on authentication status
  const targetLink = isAuthenticated ? '/medicalInfo?formType=school-work-form' : '/login';

  return (
    <div className="proceed-section mt-70">
      <div className="row">
        <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
          <div className="section-title text-center pos-rel mb-75">
            <div className="section-icon">{/* <img className="section-back-icon" src="img/section/section-back-icon.png" alt="" /> */}</div>
            <div className="section-text pos-rel">
              <h2>Request Today</h2>
            </div>
            <div className="section-line pos-rel">
              <img src="img/shape/section-title-line.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
          <div className="section-text text-center mb-30">
            <p className="pre-button-text mb-20">
              <strong>
                You will need to register at the South Vancouver Medical Clinic to proceed with your medical form completion request.
                <br />
                Click button below to proceed:
              </strong>
            </p>
            <div className="d-flex justify-content-center w-100 mb-4">
              <Link to={targetLink} className="primary_btn btn-icon btn-centered">
                Fill Out My Form
              </Link>
            </div>
            <p className="text-muted mt-20 font-italic">
              We aim to complete most forms within 1-2 business days. For urgent requests, please email <a href="mailto:info@southvanmed.com">info@southvanmed.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Map Redux state to props
const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(ProceedSection);
